/**
 * mesApi — el mes como calendario de días.
 *
 *   GET /api/mes?period=YYYY-MM
 *
 * Una celda por día del mes con su estado del cierre (`sin_movimiento` | `pendiente` |
 * `liquidado`), lo cobrado, lo que hay que girar y cuál es el paso siguiente de ese día.
 *
 * SÓLO LECTURA. Todo lo que se ejecuta del ciclo vive en el día (`diaApi.js`): el cierre es
 * diario y el mes es la grilla desde donde se entra. Una acción acá tendría que decidir
 * sobre treinta días a la vez, que es justo el modelo que se corrigió.
 *
 * Mismo patrón que diaApi.js: JWT de staff Clerk, URL vía baseUrl.js (same-origin → proxy
 * api/yoolpay/api/[endpoint].js), y el error se lanza como `Error(mensaje)`.
 *
 * @see src/services/yoolpay/diaApi.js — el día, donde sí se ejecuta
 * @see src/pages/payments/yoolpay/YoolPayMes.jsx — único consumidor
 */
import { yoolpayBaseUrl } from './baseUrl.js';

const BASE = yoolpayBaseUrl();

/**
 * El calendario de un mes.
 *
 * `period` es OBLIGATORIO en 'YYYY-MM' y payment responde 400 si falta o está mal escrito:
 * un default silencioso al mes actual dibujaría un calendario que nadie pidió, y se leería
 * como el mes que se creía estar mirando.
 */
export async function getMes(token, { period }) {
  const res = await fetch(`${BASE}/api/mes?period=${encodeURIComponent(period ?? '')}`, {
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });
  const payload = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(payload?.error || `payment respondió ${res.status}`);
  return payload;
}
